module.exports = __webpack_public_path__ + "img/junior-designer-preview.4d3a0be1.jpg";